import { ROUTER_API } from 'app/constants/api.constant';
import BaseApi from 'app/services/api/base.api';
import { BoosterOption } from '../boosterOptions';

export const boosterApi = new BaseApi({ baseURL: ROUTER_API, tokenKey: 'token', timeout: 20000 });

export type BoosterNewPlayers = Record<BoosterOption, number>;

export const getBoosterNewPlayersApi = async () => {
  const response = await boosterApi.api.get<BoosterNewPlayers>('api/v2/booster/new-players');
  return response.data;
};

export const recordBoosterVisitApi = async (option: BoosterOption) => {
  const response = await boosterApi.api.post<BoosterNewPlayers>(`api/v2/booster/visits/${option}`);
  return response.data;
};

// An XHR cannot outlive the page on `pagehide`, a beacon can; it cannot carry a header, so the token goes in the query.
export const beaconBoosterVisit = (option: BoosterOption, token: string | null): boolean => {
  if (!token || typeof navigator.sendBeacon !== 'function') {
    return false;
  }
  return navigator.sendBeacon(`${ROUTER_API}/api/v2/booster/visits/${option}?token=${encodeURIComponent(token)}`);
};
